import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { atenderCita } from "../services/citas.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const useCitaAtender = () => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const atenderCitaMutation = useMutation({
        mutationFn: atenderCita,
        onSuccess: (cita, variables, context) => {
            if(variables.paciente !== '0'){
                queryClient.invalidateQueries({ queryKey: ['citas', variables.paciente] });
                queryClient.invalidateQueries({ queryKey: ['historialCitas', variables.paciente] });
            }
            queryClient.invalidateQueries({ queryKey: ['agenda'], exact: false });
            queryClient.invalidateQueries({ queryKey: ['agendaInmunoterapia'], exact: false });
            variables.success(cita.paciente._id);
            dispatch(successNotification('Cita atendida'));
        },
        onError: (error, variables, context) => {
            variables.error();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        atenderCitaMutation,
    }
}